import { RouteTreeValue } from "@/lib/renderRouteTree";
import { SettingsPage } from "./SettingsPage";
import { Integrations } from "@/features/integrations/Integrations";
import { Members } from "@/features/members/Members";
import { Agents } from "@/features/agents/Agents";
import { BusinessHours } from "@/features/business-hours/BusinessHours";
import { Topics } from "@/v2/features/topic/Topics";
import { Brands } from "@/v2/features/brand/Brands";
import { Notifications } from "@/v2/features/notifications/Notifications";
import { useFlag } from "@/v2/components/feature-flag/FeatureFlagContext";
import { Billing } from "@/v2/features/billing/Billing";
import { CustomFields } from "@/v2/features/custom-fields/CustomFields";
import { SubTopics } from "@/v2/features/subtopics/SubTopics";
import { FieldSyncSettings } from "@/v2/features/field-sync/FieldSyncSettings";
import { ApiKeys } from "@/v2/features/api-keys/ApiKeys";
import { Gdpr } from "@/v2/features/gdpr/Gdpr";
import { AggregatedAutoResponse } from "@/v2/features/aggregated-auto-response/AggregatedAutoResponse";

export function useSettingsRouteTree(): RouteTreeValue {
  const isBillingEnabled = useFlag("billingEnabled", false);
  const isGdprSettingsEnabled = useFlag("gdpr-setting-page", false);

  const baseRoutes = [
    { path: "data-sources", elem: <Integrations />, index: true },
    { path: "members", elem: <Members /> },
    { path: "agents", elem: <Agents /> },
    { path: "business-hours", elem: <BusinessHours /> },
    { path: "topics", elem: <Topics /> },
    { path: "subtopics", elem: <SubTopics /> },
    { path: "brands", elem: <Brands /> },
    { path: "field-sync", elem: <FieldSyncSettings /> },
    { path: "api-keys", elem: <ApiKeys /> },
    { path: "auto-response", elem: <AggregatedAutoResponse /> },
  ];

  const routes = [
    ...baseRoutes,
    ...(isBillingEnabled ? [{ path: "billing", elem: <Billing /> }] : []),
    ...([{ path: "custom-fields", elem: <CustomFields /> }]),
    ...([{ path: "notifications", elem: <Notifications /> }]),
    ...(isGdprSettingsEnabled ? [{ path: "gdpr", elem: <Gdpr /> }] : []),
  ];

  return {
    root: "/settings",
    rootElement: <SettingsPage />,
    tree: routes,
  };
}

// Legacy export for backward compatibility - this will not respect feature flags
export const settingsRouteTree: RouteTreeValue = {
  root: "/settings",
  rootElement: <SettingsPage />,
  tree: [
    { path: "data-sources", elem: <Integrations />, index: true },
    { path: "members", elem: <Members /> },
    { path: "agents", elem: <Agents /> },
    { path: "business-hours", elem: <BusinessHours /> },
    { path: "topics", elem: <Topics /> },
    { path: "subtopics", elem: <SubTopics /> },
    { path: "brands", elem: <Brands /> },
    { path: "field-sync", elem: <FieldSyncSettings /> },
    { path: "api-keys", elem: <ApiKeys /> },
    { path: "notifications", elem: <Notifications /> },
    { path: "billing", elem: <Billing /> },
    { path: "auto-response", elem: <AggregatedAutoResponse /> },
  ],
};
